import { instance } from "apis/interceptor";
import axios from "axios";
import { UserRole } from "utils/role";
import { TUser } from "apis/user/index";

export type TInviteMember = {
  id: string;
  email: string;
  role: UserRole;
  expiredAt: string;
};

//FEAT: (new) 멤버 초대 내역 조회
export const getInviteMember = async (
  page: number,
  role?: number,
  searchWord?: string
): Promise<{
  success: boolean;
  totalPageNumber?: number;
  totalSearchNumber?: number;
  nowPageNumber?: number;
  memberInviteeList?: TInviteMember[];
  message?: string;
}> => {
  try {
    const res = await instance.post("/member-invitees", {
      nowPageNumber: page,
      role: role ?? null,
      searchWord: searchWord ?? null,
    });

    const { totalSearchNumber, totalPageNumber, nowPageNumber, memberInviteeList } = res.data;

    return {
      success: true,
      totalPageNumber,
      totalSearchNumber,
      nowPageNumber,
      memberInviteeList,
    };
  } catch (error) {
    return {
      success: false,
      message: `${error}`,
    };
  }
};

//FEAT: (new) 멤버 초대 대기열 등록
export const registerMemberList = async (
  role: UserRole,
  emailList: string[]
): Promise<{
  success: boolean;
  invites?: { role: UserRole; email: string; validationResult: boolean; errorMessage?: string }[];
  message?: string;
}> => {
  try {
    const res = await instance.post("/member-invitees/register", {
      role: role,
      emailList: emailList,
    });
    return {
      success: true,
      invites: res.data,
    };
  } catch (error: any) {
    if (error.response.status === 409) {
      return {
        success: false,
        message: "하루 최대 발송량을 초과하였습니다.",
      };
    }
    return {
      success: false,
      message: "멤버 초대 등록에 실패하였습니다. 다시 시도해주세요.",
    };
  }
};

//FEAT: (new) 멤버 초대 전송
export const sendInviteMember = async (
  member: {
    email: string;
    role: number;
  }[]
): Promise<{
  success: boolean;
  message?: string;
  status?: number;
}> => {
  try {
    const res = await instance.post("/member-invitees/invite", {
      memberInvitees: member,
    });

    return {
      success: res.data.result,
    };
  } catch (error: any) {
    return {
      success: false,
      message: `${error}`,
      status: error.response.status,
    };
  }
};

//FEAT: (new) 멤버 초대 재전송
export const resendInviteMember = async (
  id: string
): Promise<{
  success: boolean;
  message?: string;
}> => {
  try {
    const res = await instance.post("/member-invitees/resend", {
      id: id,
    });

    return {
      success: res.data.result,
    };
  } catch (error) {
    return {
      success: false,
      message: `${error}`,
    };
  }
};

//FEAT: (new) 멤버 초대 내역 취소
export const cancelInviteMember = async (
  id: string
): Promise<{
  success: boolean;
  message?: string;
}> => {
  try {
    const res = await instance.delete("/member-invitees", {
      data: {
        id: id,
      },
    });

    return {
      success: res.data.result,
    };
  } catch (error) {
    return {
      success: false,
      message: `${error}`,
    };
  }
};

//FEAT: (new) 멤버 초대 수락
export const acceptInviteMember = async (
  secretCode: string
): Promise<{
  success: boolean;
  statusCode?: number;
}> => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/member-invitees/accept`, {
      secretCode: secretCode,
    });
    return {
      success: res.data.result,
    };
  } catch (error: any) {
    return {
      success: false,
      statusCode: error.response.status,
    };
  }
};

//FEAT: (new) 내 초대장 조회하기
export const getMyInviteMember = async (): Promise<{
  success: boolean;
  members?: TUser[];
  message?: string;
}> => {
  try {
    const res = await instance.post("/member-invitees/my");

    return {
      success: true,
      members: res.data,
    };
  } catch (error) {
    return {
      success: false,
      message: `${error}`,
    };
  }
};

//FEAT: (new) 워크스페이스 초대 수락
export const acceptInviteWorkspace = async (
  id: string
): Promise<{
  success: boolean;
  statusCode?: number;
}> => {
  try {
    const res = await instance.post("/member-invitees/my/accept", {
      id: id,
    });
    return {
      success: res.data.result,
    };
  } catch (error: any) {
    return {
      success: false,
      statusCode: error.response.status,
    };
  }
};
